const features = [
  {
    icon: 'ri-movie-line',
    title: '智能剪辑工具',
    description: '一键生成字幕、智能滤镜调色、丰富的转场特效和背景音乐库，三分钟做出专业级短视频。',
  },
  {
    icon: 'ri-group-line',
    title: '活跃创作者社区',
    description: '百万创作者在这里分享交流，参与热门挑战，获取创作灵感，一起成长进步。',
  },
  {
    icon: 'ri-fire-line',
    title: '精准内容推荐',
    description: '基于AI算法的个性化推荐系统，让优质内容找到对的人，让每个作品都有被看见的机会。',
  },
  {
    icon: 'ri-money-cny-circle-line',
    title: '多元变现方式',
    description: '播放收益、创作者激励、粉丝打赏、品牌合作，多种方式让你的创作价值最大化。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '版权保护体系',
    description: '自动水印、原创声明、区块链存证，全方位保护你的创作成果，让抄袭无处遁形。',
  },
  {
    icon: 'ri-cloud-line',
    title: '云端存储同步',
    description: '无限云端存储空间，多设备自动同步草稿和素材，随时随地继续你的创作之旅。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择黄瓜视频？
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            六大核心功能，为创作者提供全方位的支持与服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-xl bg-background-100/70 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}